module.exports = __webpack_public_path__ + "media/images/mailer/activation_customer/briefing_de-5a277f63bdb08b90cf7b6a4123f9f8be.gif";